import { forwardRef, Icon, IconProps } from "@chakra-ui/react";
export default forwardRef<IconProps, "svg">((props, svgRef) => (
  <Icon
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={svgRef}
    {...props}
  >
    <path
      fill="currentColor"
      d="M23.033.967a3.3 3.3 0 00-4.667 0L2.81 16.523l4.667 4.667L23.033 5.634a3.3 3.3 0 000-4.667zM5.907 22.732l-4.64-4.64a2.93 2.93 0 00-.576 1.246l-.669 3.346a1.1 1.1 0 001.294 1.294l3.346-.67a2.91 2.91 0 001.245-.576z"
    />
  </Icon>
));
